import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import Element from 'element-ui'
import VueAreaLinkage from "vue-area-linkage";
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'
import '@/assets/css/base.css'
import UUID from 'vue-uuid';

import "./service";
import "./plugins";
import "./common";


// 引入 富文本
import VueQuillEditor from 'vue-quill-editor';
import '../theme/index.css'

import VueKindEditor from 'vue-kindeditor'

Vue.use(VueKindEditor)

import {Notification} from 'element-ui'
import {MessageBox} from 'element-ui';
import {Message} from 'element-ui';

// 自定义注册
import CheckInput from '@/components/Common/CheckInput/CheckInput'

//三级联动
import 'vue-area-linkage/dist/index.css';

//滚动条
import vuescroll from 'vuescroll/dist/vuescroll-native';
import 'vuescroll/dist/vuescroll.css';

import echarts from 'echarts';

Vue.use(VueQuillEditor);

// 引入ElementUI
Vue.use(Element);
Vue.use(UUID);
// 引入三级联动
Vue.use(VueAreaLinkage);
//滚动条
Vue.use(vuescroll);

// 全局注册
Vue.component('check-input', CheckInput)

Vue.filter('centsToYuan', function (value) {
  if (value == undefined || (typeof value == 'string' && value == '')) {
    return ''
  }
  const s = (value / 100).toFixed(2);
  return s
})


Vue.filter('fillZero', function (value) {
  if (!value) {
    return ''
  }
  return value.toFixed(2)
})

// echarts
Vue.prototype.$echarts = echarts;

// 服务地址
Vue.prototype.$publicPath = process.env.BASE_URL
// 服务地址
Vue.prototype.$baseUrl = process.env.VUE_APP_SECRET_BASE_API

Vue.prototype.$baseNewUrl = process.env.VUE_APP_SECRET_BASE_NEW_API

// 文件获取地址
Vue.prototype.$fileUrl = process.env.VUE_APP_SECRET_BASE_API + '!service/file/~java/Downloader.get?type=thumb&id='

Vue.prototype.$loginUrl = '!ESale/Mall/UI/~view/login';

Vue.prototype.$deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}


Vue.prototype.$notifySuccess = (message) => {
  Notification({
    title: '操作成功',
    message: message,
    type: 'success',
    duration: 2000
  });
};

Vue.prototype.$notifyError = (message) => {
  Notification({
    title: '错误提示',
    message: message,
    type: 'error',
    duration: 3000
  });
};

Vue.prototype.$msgSuccess = (message) => {
  return Message({
    message: message,
    type: 'success'
  });
};

Vue.prototype.$msgError = (message) => {
  return Message({
    message: message,
    type: 'error'
  });
};

Vue.prototype.$confirmWarning = (message) => {
  return MessageBox(message, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
};

Vue.config.productionTip = false

// 限制输入特殊字符（只需要在<el-input v-model="postForm.note"></el-input>中加上  @input="e => postForm.note = validForbid(e)",）
Vue.prototype.validForbid = function (value) {
  // value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "");
  value = value.replace(/[`~\<>:"|/;'\\·~￥……——\|《》“”、‘’、]/g, '').replace(/\s/g, "");
  return value;
}

// 限制输入特殊字符（会员名称）
Vue.prototype.validMemberName = function (value) {
  value = value.replace(/[`~\<>:"|/;！+=!@#￥%&*'\\·~￥……\|《》“”、‘’、]/g, '').replace(/\s/g, "");
  return value;
}


const Bus = new Vue();

new Vue({
  router,
  store,
  data: { Bus },
  render: h => h(App)
}).$mount('#app')
